import { useSnapshot } from "valtio"
import { configStore, contractsStore, entityStore, loginStore, bookingsStore } from "../state/CommonState"
import { $c, $cg, $cr, AgInput, AgSelect } from '../components/AgComponents'
import EntityApi from "../state/entity-api"
import AguserApi from "../state/AguserApi"
import { useEffect, useState } from "react"
import Api from "../state/Api"
import { Roles, ServerLists } from "../StaticData"
import stateList from "../static-data/states"
import AgFile from "../components/AgFile"
import LCLScheduleComp from "./LCLScheduleComp"
import BookingsApi from "../state/bookings-api"
import { incoTermsList, commodityList, hazardousList } from "../StaticData"
import BookingConfirmation from "./booking-confirmation"
import Agswitch from "../components/ag-switch"
import { Agyesno } from "../components/Agyesno"
import FCLScheduleComp from "./FCLScheduleComp"
import AirScheduleComp from "./AirScheduleComp"

export default function CarrierWebForm(props) {
    const [space, setSpace] = useState('')
    const [companyName, setCompanyName] = useState('')
    useSnapshot(loginStore)
    useSnapshot(bookingsStore)
    useSnapshot(contractsStore)
    useSnapshot(configStore)
    useSnapshot(entityStore)
    let brec = bookingsStore.current
    const aguser = loginStore.userRec.aguserRec
    useEffect(() => {
        EntityApi.getList()
        brec.firstName = aguser.firstName
        brec.lastName = aguser.lastName
        brec.phone = aguser.phone
        brec.email = loginStore.email
        brec.incoTerms = contractsStore.current.incoTerms
        brec.commodityType = contractsStore.current.commodityType
        brec.carrierMBL = 'No'
        brec.company = brec.contract.gst
        console.log('GOT COMPANY AS ========', brec.company, entityStore.list.length)
        const ent = entityStore.list.filter(e1 => e1.gst === brec.company)
        if (ent.length > 0) {
            let entity = ent[0]
            console.log('entity found =', entity)
            setCompanyName(entity.entityName)
            brec.address = entity.address
            brec.country = entity.country
        } else {
            setCompanyName(brec.contract.gst)
        }
    }, [])
    const domain = loginStore.email.split('@')[1]

    let title = 'Carrier Web Form'
    useSnapshot(contractsStore)

    const entity1 = entityStore.entityRec
    const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }
    const filecat = '' + Date.now()
    const enableMBL = () => (contractsStore.current.shipmentType.indexOf('FCL') >= 0
        && contractsStore.current.shipmentScope.endsWith('ort')) ? {} : { disabled: 1 }
    let commList = commodityList
    if (brec.contract.hazardous === 'Yes') commList = hazardousList
    const stype = () => brec.contract.shipmentType.toUpperCase().substr(0, 3)
    if(contractsStore.current.fba!=undefined && (brec.fba==undefined || contractsStore.current.fba!=brec.fba)){
        brec.fba=contractsStore.current.fba
    }
    return (
        <div style={{ fontSize: '0.8rem' ,paddingTop:"10px"}}>
            <BookingConfirmation />
            {
                stype() === 'LCL' ?
                    <LCLScheduleComp data={bookingsStore.current.schedule} viewonly={true} /> :
                    stype === 'FCL' ?
                        <FCLScheduleComp data={bookingsStore.current.schedule} viewonly={true} /> :
                        <AirScheduleComp />
            }

            <div className="columns">
                <$cr n='2'>First Name{space}</$cr>
                <$c n='3'>
                    <input className="input is-small" value={brec.firstName}
                        onChange={(e) => brec.firstName = e.target.value} />
                </$c>
                <$cr n='2'>Last Name22</$cr>
                <$c n='3'>
                    <input className="input is-small" value={brec.lastName}
                        onChange={(e) => brec.last = e.target.value} />
                </$c>
            </div>
            <div className="columns">
                <$cr n='2'>Email ID</$cr>
                <$c n='3'>
                    <input className="input is-small" value={brec.email}
                        onChange={(e) => brec.email = e.target.value} />
                </$c>
                <$cr n='2'>Contact Number</$cr>
                <$c n='3'>
                    <input className="input is-small" value={brec.phone}
                        onChange={(e) => brec.phone = e.target.value}  onKeyDown={(e) =>
                            ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                          }
                           onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                          }}/>
                </$c>
            </div>
            <div className="columns">
                <$cr n='2'>Company Name</$cr>
                <$c n='3'>
                    {/*<select className="select is-fullwidth is-small" value={brec.company}
                        onChange={(e) => {
                            brec.company = e.target.value
                            const ent = entityStore.list.filter(e1 => e1.gst === e.target.value)[0]
                            brec.address = ent.address
                            brec.country = ent.country
                            //setSpace(space===''?' ':'')
                            console.log('Address', ent.address, brec.address)
                        }} >
                        <option value=''></option>
                        {entityStore.list.map(e => <option value={e.gst}>{e.entityName} - {e.state}</option>)}
                    </select>*/}
                    {companyName}
                </$c>
                <$cr n='2'>Address</$cr>
                <$c n='3'>
                    {brec.address}
                </$c>
            </div>
            <div className="columns is-narrow">
                <$cr n='2'>Zip Code</$cr>
                <$c n='3'>
                    <input className="input is-small" value={brec.pin}
                        onChange={(e) => brec.pin = e.target.value} />
                </$c>
                <$cr n='2'>Country</$cr>
                <$c n='3'>
                    {brec.country}
                </$c>
            </div>

            <div className="columns">
                <$cr n='2'>Incoterms</$cr>
                <$c n='3'>
                    {
                        (!brec.incoTerms || brec.incoTerms.length < 1) ?
                            <select className="select is-fullwidth is-small" value={brec.incoTerms}
                                onChange={(e) => {
                                    brec.incoTerms = e.target.value
                                }} >
                                <option value=''></option>
                                {incoTermsList.map(e => <option value={e}>{e}</option>)}
                            </select> : brec.incoTerms
                    }
                </$c>
                <$cr n='2'>Commodity Type</$cr>
                <$c n='3'>
                    {
                        (!brec.commodityType || brec.commodityType.length < 1) ?
                            <>
                                <input defaultValue={brec.commodityType} list='commodities'
                                    onBlur={(e) => brec.commodityType = e.target.value}
                                    className="input is-small" />
                                <datalist id='commodities'>
                                    {
                                        commList.map(e => <option value={e} />)
                                    }
                                </ datalist>
                            </> : brec.commodityType
                    }
                </$c>
            </div>
            <div className="columns is-narrow">      
                <$cr n='2'>FBA</$cr>       
                <$c n='2'>
                    {
                        (contractsStore.current.fba!=undefined)?<Agyesno disabled={true} label='' record={brec} name='fba' />:
                        <Agyesno label='' record={brec} name='fba' />
                    }
                </$c>
                <$c n='8'>
                </$c>
            </div>
            <div className="columns is-narrow">
                <$cr n='2'>Special Instructions</$cr>
                <$c n='6'>
                    <textarea rows='3' style={{ fontSize: '0.8rem' }} className="textarea" value={brec.specialInstructions}
                        onChange={(e) => brec.specialInstructions = e.target.value} />
                </$c>
                <$c n='2'>
                    <Agyesno {...enableMBL()} label='Do you require a Direct Carrier MBL?'
                        record={brec} name='carrierMBL' />
                </$c>
            </div>

            <div className="columns">
                <$c n='1'></$c>
                <$c n='9'>
                    <div className="table-container ">
                        <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                            <thead>
                                <tr>
                                    <th style={{ width: '16rem' }}>Required Documents</th>
                                    <th>Document Uploaded</th>
                                    <th style={{ width: '12rem' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    (
                                        (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals'))
                                        || (brec.contract.hazardous === 'Yes')
                                    ) ?
                                    <tr>
                                        <td>MSDS1</td>
                                        <td>{renderLink(brec.msds_filename)}</td>
                                        <td>
                                            <AgFile source='carrierwebform' cat={filecat} filetype='msds'
                                                callback={(filename) => brec.msds_filename = filename} />
                                        </td>
                                    </tr>
                                    : <></>
                                }
                                {
                                    (brec.commodityType && brec.commodityType.startsWith('Non-Hazardous Chemicals')) ?
                                        <tr>
                                            <td>Non-DG Declaration</td>
                                            <td>{renderLink(brec.nondgdecl_filename)}</td>
                                            <td>
                                                <AgFile cat={filecat} filetype='nondgdecl'
                                                    callback={(filename) => brec.nondgdecl_filename = filename} />
                                            </td>
                                        </tr> : <></>
                                }
                                {
                                    (brec.contract.hazardous === 'Yes') ?
                                        <>
                                            <tr>
                                                <td>DG Declaration</td>
                                                <td>{renderLink(brec.dgdecl_filename)}</td>
                                                <td>
                                                    <AgFile cat={filecat} filetype='dgdecl'
                                                        callback={(filename) => brec.dgdecl_filename = filename} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>IIP Certificate</td>
                                                <td>{renderLink(brec.iipcert_filename)}</td>
                                                <td>
                                                    <AgFile cat={filecat} filetype='iipcert'
                                                        callback={(filename) => brec.iipcert_filename = filename} />
                                                </td>
                                            </tr>
                                        </> : <></>
                                }
                            </tbody>
                        </table>
                    </div>
                </$c>
            </div>
            <div className="columns">
                <$cr n='1'></$cr>
                <$c n='9'>
                    <button className="button is-warning" onClick={(e) => {
                        configStore.scheduleOrCarrierform = 'schedule'
                    }}>
                        <span className="icon" style={{ marginRight: '5px' }}>
                            <i class="fa-solid fa-circle-left"></i>
                        </span>
                        Schedules
                    </button>
                    <button className="button is-link" style={{ float: 'right' }} onClick={(e) => {
                        if (!brec.incoTerms || brec.incoTerms.length < 1) {
                            configStore.setModalMessage('IncoTerms Mandatory')
                            return
                        }
                        if (!brec.commodityType || brec.commodityType.length < 1) {
                            configStore.setModalMessage('Commodity Type Mandatory')
                            return
                        }
                        BookingsApi.saveBooking()
                    }}>
                        Confirm and Save Booking
                    </button>
                </$c>
            </div>
        </div>
    )
}